const fileTypesEnum = {
   image: 'image',
   video: 'video',
   powerpoint: 'powerpoint',
   document: 'document',
   pdf: 'pdf',
   signature: 'signature',
};

export type FileType = (typeof fileTypesEnum)[keyof typeof fileTypesEnum];

export default Object.freeze(fileTypesEnum);
